export default __webpack_public_path__ + "static/media/afghanBorderLineUpdated.88004503.kml";